/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  if (!time) {
    return ''
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

export function formatNum (n, isNopoint = 1) {
  if (!n) {
    return n
  }
  //  let num = parseFloat(Number(val).toFixed(wei))
  //   let [integer, decimal] = String.prototype.split.call(num, '.')
  //   integer = integer.replace(/\d(?=(\d{3})+$)/g, '$&,') // 正则先行断言
  //   return `${integer}${decimal ? '.' + decimal : ''}`
  const regex = /\d{1,3}(?=(\d{3})+(\.|$))/g // 替换规则
  n = String(Math.round(n * Math.pow(10, 2))) // 乘100 四舍五入
  let integer = n.substr(0, n.length - 2).replace(regex, '$&,') // 最后两位前的为整数
  let decimal = n.substr(n.length - 2) // 最后两位为小数
  let result = ''
  if (isNopoint) {
    //不要小数
    result = `${integer || 0}`
  } else {
    result = `${integer || 0}.${decimal}`
  }
  return result
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}
/**
 * @param {Number} num
 * @returns {String}
 */
export const getAfterDate = function (num = 0, utc4, format = '{y}-{m}-{d}') {
  let date = utc4 ? new Date(getLocalTime(-4)) : new Date()
  date.setDate(date.getDate() + num)
  return parseTime(date, format)
}

export const getDataTimeAfterDate = function(num = 0) {
  const start = new Date(new Date().toLocaleDateString()).getTime()
  const end =
    new Date(new Date().toLocaleDateString()).getTime() +
    (24 * 60 * 60 * 1000 - 1000) +
    num * 24 * 60 * 60 * 1000

  return [start, end]
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xdc00 && code <= 0xdfff) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}


export function downloadHandler(res, fileName, type) {
  return new Promise(async (resolve, reject) => {
    let data = res.data
    if(type === 'zip') {
      const blob = new Blob([data],{type: 'application/zip'})
      if (!fileName) {
        let contentDisposition = res.headers['content-disposition']
        if (contentDisposition) {
          fileName = window.decodeURI(
            res.headers['content-disposition'].split('=')[1],
            'UTF-8'
          )
        }
      }
      executeDownload(blob, fileName)
      resolve({ code: 0 })
    } else {
      let reader = new FileReader()
      const text = await data.text()
      if (/^\{/.test(text)) {
        return resolve(JSON.parse(text))
      }
      reader.onload = (e) => {
        if (
          e.target.result.indexOf('Result') !== -1 &&
          JSON.parse(e.target.result).Result === false
        ) {
          reject(new Error('download error'))
          // 进行错误处理
        } else {
          if (!fileName) {
            let contentDisposition = res.headers['content-disposition']
            if (contentDisposition) {
              fileName = window.decodeURI(
                res.headers['content-disposition'].split('=')[1],
                'UTF-8'
              )
            }
          }
          executeDownload(data, fileName)
          resolve({ code: 0 })
        }
      }
      reader.readAsText(data)
      resolve(res.data)
    }
  })
}
export function executeDownload(data, fileName) {
  if (!data) {
    return
  }
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export function getTimeCode(tiemCode) {
  let offset = new Date().getTimezoneOffset()
  let start = ''
  let end = ''
  let deltaDay = new Date().getDay()
  let day = ''
  if (deltaDay === 0) {
    // 一个星期中的第几天
    day = 6
  } else {
    day = deltaDay - 1
  }
  let time = parseTime(new Date(getLocalTime(-4)), '{y}/{m}/{d}') + ' 00:00:00'
  if (+tiemCode === 2 || tiemCode === 'Daily') {
    start = new Date(time).getTime() - offset * 60 * 1000 + 4 * 60 * 60 * 1000
    end =
      new Date(time).getTime() +
      (24 * 60 * 60 * 1000 - 1) -
      offset * 60 * 1000 +
      4 * 60 * 60 * 1000
  }
  if (+tiemCode === 4) {
    start = new Date(time).getTime() - 24 * 60 * 60 * 1000
    end = new Date(time).getTime() - 1 - offset * 60 * 1000 + 4 * 60 * 60 * 1000
  }
  if (+tiemCode === 6 || tiemCode === 'Weekly') {
    time = parseTime(new Date(), '{y}/{m}/{d}') + ' 00:00:00'
    start =
      new Date(time).getTime() -
      day * 24 * 60 * 60 * 1000 -
      offset * 60 * 1000 +
      4 * 60 * 60 * 1000
    end =
      new Date(time).getTime() -
      (day - 7) * 24 * 60 * 60 * 1000 -
      1 -
      offset * 60 * 1000 +
      4 * 60 * 60 * 1000
  }
  if (+tiemCode === 7) {
    start =
      new Date(time).getTime() -
      (day + 7) * 24 * 60 * 60 * 1000 -
      offset * 60 * 1000 +
      4 * 60 * 60 * 1000
    end =
      new Date(time).getTime() -
      day * 24 * 60 * 60 * 1000 -
      1 -
      offset * 60 * 1000 +
      4 * 60 * 60 * 1000
  }
  if (+tiemCode === 8 || tiemCode === 'Monthly') {
    time = parseTime(new Date(), '{y}/{m}/{d}') + ' 00:00:00'
    let startDay = new Date().getDate() - 1
    let date = new Date()
    let currentMonth = date.getMonth()
    let nextMonth = ++currentMonth
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
    let oneDay = 1000 * 60 * 60 * 24
    let lastTime = new Date(nextMonthFirstDay - oneDay)
    let endDay = lastTime.getDate()
    start =
      new Date(time).getTime() -
      startDay * 24 * 60 * 60 * 1000 -
      offset * 60 * 1000 +
      4 * 60 * 60 * 1000
    end =
      new Date(time).getTime() -
      (startDay - endDay) * 24 * 60 * 60 * 1000 -
      1 -
      offset * 60 * 1000 +
      4 * 60 * 60 * 1000
  }
  if (+tiemCode === 9) {
    let startDay = new Date().getDate() - 1
    let date = new Date()
    let currentMonth = date.getMonth()
    let nextMonthFirstDay = new Date(date.getFullYear(), currentMonth, 1)
    let oneDay = 1000 * 60 * 60 * 24
    let lastTime = new Date(nextMonthFirstDay - oneDay)
    let endDay = lastTime.getDate()
    start =
      new Date(time).getTime() -
      (startDay + endDay) * 24 * 60 * 60 * 1000 -
      offset * 60 * 1000 +
      4 * 60 * 60 * 1000
    end =
      new Date(time).getTime() -
      startDay * 24 * 60 * 60 * 1000 -
      1 -
      offset * 60 * 1000 +
      4 * 60 * 60 * 1000
  }
  if (tiemCode === 'year') {
    let year = new Date(new Date(getLocalTime(-4))).getFullYear()
    start = new Date(year + '-01-01 00:00:00').getTime()
    end = new Date(year + '-12-31 23:59:59').getTime()
  }
  return [start, end]
}
export function getLocalTime(i, time) {
  if (typeof i !== 'number') return
  let d = time ? new Date(time) : new Date()
  let len = d.getTime()
  let offset = d.getTimezoneOffset() * 60000
  let utcTime = len + offset
  const fixedNum = d.getTimezoneOffset()/60 + i 
  const fixed =
    ((12 + fixedNum) * 2) *
    60 *
    60 *
    1000
  return new Date(utcTime + 60 * 60 * 1000 * i - fixed).getTime()
}